/**
 * Describes the compatibility types.
 */
export enum Compatibility {
    /**
     * Compatible.
     */
    Ok,
    /**
     * SDK is older.
     */
    SdkOld,
    /**
     * SDK is newer.
     */
    SdkNew,
}
